var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_cof.js
// module id = 19
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11